<template>
  <div
    class="spinner-border"
    role="status"
  >
  </div>
</template>

<script>

</script>

<style scoped>
  .spinner-border {
    width: 10rem;
    height: 10rem;
    color: var(--color-greeny) !important;
  }
</style>